// Stickers on Rolls pricing (AUD, ex GST). Used only by the Stickers on Rolls page.
// Media Point supplier total cost per size at each tier (approved retail table ÷ 2.1).
// Rules: lower-tier supplier unit cost (no interpolation); under 700 → 700-tier unit cost;
// over 100,000 → 100,000-tier unit cost; retail = MAX(qty × unit × 2.1, $240). Shape/stock/corners do not affect price.
export const ROLL_TIERS = [700, 1000, 2500, 5000, 10000, 25000, 50000, 100000];
export const ROLL_MARKUP = 2.1;
export const ROLL_MIN_CHARGE = 240;

export const ROLL_SIZES = [
  { id: "40x40", group: "square", label: "40 × 40 mm", w: 40, h: 40, supplier: [120, 120, 120, 148, 228, 429, 699, 1010] },
  { id: "60x60", group: "square", label: "60 × 60 mm", w: 60, h: 60, supplier: [120, 120, 154, 245, 390, 732, 1079, 2090] },
  { id: "80x80", group: "square", label: "80 × 80 mm", w: 80, h: 80, supplier: [120, 129, 219, 360, 594, 988, 1845, 3604] },
  { id: "100x100", group: "square", label: "100 × 100 mm", w: 100, h: 100, supplier: [120, 145, 262, 412, 677, 1171, 2266, 4417] },
  { id: "150x150", group: "square", label: "150 × 150 mm", w: 150, h: 150, supplier: [176, 238, 444, 717, 1043, 2513, 4891, 9629] },
  { id: "30x50", group: "rect", label: "30 × 50 mm", w: 30, h: 50, supplier: [120, 120, 120, 143, 214, 407, 670, 974] },
  { id: "50x75", group: "rect", label: "50 × 75 mm", w: 50, h: 75, supplier: [120, 120, 153, 243, 386, 727, 1067, 2066] },
  { id: "50x100", group: "rect", label: "50 × 100 mm", w: 50, h: 100, supplier: [120, 120, 161, 271, 424, 772, 1210, 2347] },
  { id: "50x125", group: "rect", label: "50 × 125 mm", w: 50, h: 125, supplier: [120, 123, 205, 345, 535, 948, 1697, 3328] },
  { id: "100x150", group: "rect", label: "100 × 150 mm", w: 100, h: 150, supplier: [147, 169, 344, 533, 817, 1689, 3312, 6435] },
];

export const ROLL_SHAPES = { square: ["Square", "Round", "Custom"], rect: ["Rectangle", "Oval", "Custom"] };
export const ROLL_STOCKS = ["White BOPP", "Paper"];
export const ROLL_CORNERS = [1, 2, 3, 5];
export const hasCorners = (shape) => shape === "Square" || shape === "Rectangle";

export function rollStickerPrice({ sizeId, qty }) {
  const size = ROLL_SIZES.find((s) => s.id === sizeId);
  const n = Number(qty);
  if (!size) return { status: "invalid", message: "Choose a sticker size." };
  if (!Number.isInteger(n) || n < 1) return { status: "invalid", message: "Enter a whole-number quantity of 1 or more." };
  let i = 0;
  ROLL_TIERS.forEach((t, j) => { if (n >= t) i = j; });
  const unitCost = size.supplier[i] / ROLL_TIERS[i];
  const raw = n * unitCost * ROLL_MARKUP;
  const price = Math.round(Math.max(raw, ROLL_MIN_CHARGE) * 100) / 100;
  return { status: "ok", price, total: n, pricedSize: size.label, minimumApplied: raw < ROLL_MIN_CHARGE, minCharge: ROLL_MIN_CHARGE };
}
